import { Grid } from '@mui/material'
import { useApiQuery } from '../../../../../core/api/useApiQuery'
import { fetchAllRatingsReportByPeriod } from '../fetchSurveyReport'
import { MRT_ColumnDef, MRT_ToggleGlobalFilterButton } from 'material-react-table'
import { useAppLocalization } from '../../../../localization/components/AppLocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useMemo, useState } from 'react';
import { DateTime } from 'luxon';
import { AllRatingsReport, TableRatingsReport } from '../allRatings'
import { DropdownExportButtonRatings } from './DropdownExportButtonRatings';
import { SelectSurvey } from './SelectSurvey';
import { makeStyles } from "tss-react/mui"
import { LocalizedMaterialReactTable } from '../../../../localization/components/LocalizedMaterialReactTable';



export function AllRatingsTab() {
    const { l10n } = useAppLocalization()


    const queryResult: AllRatingsReport = {
        "reportDetails": {
            "startDate": "2023-02-26",
            "endDate": "2023-04-25",
            "reportTime": "2023-04-12T15:46:30.081"
        },
        "ratings": [
            {
                "id": 1,
                "created": "2023-01-01T12:55:22",
                "orderId": 54522,
                "webshop": {
                    "name": "Shop 1"
                },
                "survey": {
                    "type": "SMILEY",
                    "id": 1,
                    "name": "My kitchen survey",
                    "questions": [
                        {
                            "id": 1,
                            "smiley": {
                                "value": "Bad",
                                "topics": [
                                    {
                                        "id": 5,
                                        "value": "Estimate"
                                    },
                                    {
                                        "id": 7,
                                        "value": "The food was cold"
                                    }
                                ],
                                "comment": "Everything about the delivery was baaaaaad!"
                            }
                        },
                        {
                            "id": 2,
                            "smiley": {
                                "value": "Good",
                                "topics": [
                                    {
                                        "id": 8,
                                        "value": "Taste"
                                    },
                                    {
                                        "id": 9,
                                        "value": "Amount"
                                    },
                                    {
                                        "id": 10,
                                        "value": "Variation"
                                    }
                                ]
                            }
                        }
                    ]
                }
            },
            {
                "id": 2,
                "created": "2023-01-01T12:57:22",
                "orderId": 54528,
                "webshop": {
                    "name": "Shop 1"
                },
                "survey": {
                    "type": "SMILEY",
                    "id": 1,
                    "name": "My kitchen survey",
                    "questions": [
                        {
                            "id": 2,
                            "smiley": {
                                "value": "Good",
                                "topics": [
                                    {
                                        "id": 8,
                                        "value": "Taste"
                                    },
                                    {
                                        "id": 9,
                                        "value": "Amount"
                                    }
                                ],
                                "comment": "This is another comment"
                            }
                        }
                    ]
                }
            }
        ]
    }


    const [startDate, setStartDate] = useState<DateTime | null>(DateTime.now().minus({ days: 14 }));
    const [chosenStartDate, setChosenStartDate] = useState<string>(DateTime.now().toISODate());

    const [endDate, setEndDate] = useState<DateTime | null>(DateTime.now());
    const [chosenEndDate, setChosenEndDate] = useState<string>(DateTime.now().toISODate());


    // TODO Hamza use queryResult when backend is ready
    const fetchAllRatingReportByPeriodQueryResult = useApiQuery(fetchAllRatingsReportByPeriod, {
        queryName: "get-all-rating-report",
        dependencies: {},
    })



    const tableData = useMemo(() => {
        try {
            if (queryResult) {
                const data = queryResult
                return data.ratings.map((rating) => ({
                    ...rating,
                    startDate: data.reportDetails.startDate,
                    endDate: data.reportDetails.endDate
                }))
            }

            return []

        } catch (error: any) {
            // TODO test if you still need this since it's handled globally

            return []
        }

    }, [queryResult])


    const columns = useMemo<MRT_ColumnDef<TableRatingsReport>[]>(
        () => [
            {
                header: "Time",
                accessorKey: 'startDate',
            },
            // {
            //     header: "Question",
            //     accessorKey: 'survey.questions',
            // },
            {
                header: "Score",
                accessorFn: (originalRow) => (originalRow.survey.questions[0].smiley.value),
            },


        ],
        [],
    );


    const useStyles = makeStyles()((_theme) => ({

    }))


    const { classes, cx } = useStyles()


    return (
        <Grid paddingTop="3rem" >
            <SelectSurvey />
            <LocalizedMaterialReactTable
                columns={columns}
                data={tableData}
                enableRowSelection
                enableClickToCopy={false}
                enableColumnOrdering
                enableStickyHeader
                enableDensityToggle={false}
                initialState={{ density: 'comfortable' }}
                enableHiding={false}
                enableRowActions
                enableGrouping
                muiTableContainerProps={{ sx: { maxHeight: "100%" } }}
                positionActionsColumn="last"
                enableColumnDragging={false}
                // renderRowActionMenuItems={({ row }) => [(
                //     <LocalizedStrict id="office-purchase-receipt">
                //         <MenuItem onClick={() => showReceipt(row.original)}>
                //             Receipt
                //         </MenuItem>
                //     </LocalizedStrict>
                // )]}
                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: '',
                    },
                }}
                // // TODO insert this icon
                // renderRowActions={({ row }) => (
                //     <FontAwesomeIcon size='2x' icon={faCircleEllipsis} />
                // )}


                renderToolbarInternalActions={({ table }) => (
                    <>
                        <DropdownExportButtonRatings rowsIsSelected={!table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()} containsRows={table.getPrePaginationRowModel().rows.length === 0}
                            allRowsWithFilter={table.getPrePaginationRowModel().rows}
                            seletecRows={table.getSelectedRowModel().rows}
                            chosenStartDate={chosenStartDate}
                            chosenEndDate={chosenEndDate}
                        />
                        <MRT_ToggleGlobalFilterButton table={table} />

                    </>
                )}
                renderTopToolbarCustomActions={({ table }) => (
                    <Grid container direction={'column'} width="80%">
                        <Grid container justifyContent="start" alignItems="center" paddingBottom="1rem" marginLeft="1rem">
                            <DatePicker
                                sx={{ width: "9rem", marginRight: "2rem", marginBottom: "1rem" }}
                                value={startDate}
                                onChange={(newValue) => setStartDate(newValue)}
                                onAccept={(newValue) => setChosenStartDate(newValue?.toISODate() ?? "")}
                                label={l10n.getString("office-start-date")}
                                slotProps={{ textField: { variant: "standard", size: "small" } }} />
                            <DatePicker
                                sx={{ width: "9rem", marginBottom: "1rem" }}
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                onAccept={(newValue) => setChosenEndDate(newValue?.toISODate() ?? "")}
                                label={l10n.getString("office-end-date")}
                                slotProps={{ textField: { variant: "standard", size: "small" } }} />
                        </Grid>
                    </Grid>
                )}
                // state={{
                //     isLoading: queryResult.isLoading,
                //     showProgressBars: queryResult.isFetching,
                // }}
            />
        </Grid >
    )
}
